import { CustomElement } from '@aurelia/runtime-html';
export const name = "textareaex";
export const template = "<template>\n  <textarea value.bind=\"value\" class=\"form-control hidden-print\" rows.bind=\"rows\" maxlength.bind=\"maxlength\" placeholder.bind=\"placeholder\"\n    disabled.bind=\"disabled\" tabindex.bind=\"tabindex\" ref=\"textarea\"\n    style=\"padding-left: ${px}px; padding-top: ${py}px; padding-bottom: ${py}px; border: ${border}\"></textarea>\n  <div if.bind=\"value\" class=\"textarea visible-print ${breakword ? 'break-word' : ''}\" style=\"white-space: pre-wrap\">${value}</div>\n  <small class=\"form-text text-muted text-right hidden-print\" if.bind=\"counter\">\n    ${value.length || 0} / ${maxlength}\n  </small>\n</template>";
export default template;
export const dependencies = [  ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
